export default "__VITE_ASSET__DAyG5ire__"